import { useIntl } from 'react-intl';

import { ListCardGroup } from 'components/list-card-group';
import { ListCardGroupVariant } from 'components/list-card-group/types';

import { Modifier } from '../modifier';
import { IModifierData } from '../modifier/types';

import { ProductSelectedItemCustomizationContainer } from './styled';
import { IProductSelectedItemCustomization } from './types';
import { getModifiersWithSelections } from './utils';

export const ProductSelectedItemCustomization: React.FC<IProductSelectedItemCustomization> = ({
  modifierSelections,
  onModifierSelectionsChange,
  onComboSlotModifierSelectionsUpdate,
  pickerAspectExclusions,
  selectedItem,
}) => {
  const { formatMessage } = useIntl();
  const { options: selectedItemModifiers } = selectedItem;

  const modifiers = getModifiersWithSelections({
    modifiers: selectedItemModifiers,
    modifiersMap: modifierSelections,
    pickerAspectExclusions,
  });

  if (!modifiers.length) {
    return null;
  }

  const customizationHeader = formatMessage({ id: 'customizations' });

  return (
    <ProductSelectedItemCustomizationContainer testID="product-selected-item-customization">
      <ListCardGroup
        isFullContainer
        items={modifiers}
        variant={ListCardGroupVariant.SINGLE}
        header={customizationHeader}
        renderItem={({ item: modifier }: { item: IModifierData }) => {
          return (
            <Modifier
              key={`modifier-${modifier.modifier.name?.locale}`}
              {...modifier}
              onSelectionsChange={selections => {
                onModifierSelectionsChange(selections, modifier.modifier);
                onComboSlotModifierSelectionsUpdate();
              }}
              selectedItem={selectedItem}
            />
          );
        }}
      />
    </ProductSelectedItemCustomizationContainer>
  );
};
